export default "__VITE_ASSET__oyzPmixT__"